require('./style.less');

var Marionette = require('marionette'),
    SearchBarView = require('../../../common/searchBar/searchBar'),
    BabySitterView = require('../../../common/BabySitterView'),
    PageSelectTemplate = require('./pageSelectOptions.hbs');

require('extendJQuery');  //unselectable, jqErr
require('jqToggleButton');

module.exports = BabySitterView.extend({
    template: require('./template'),
    ui: {
        pageSelect:         '.esPageSelect',
        toggleWrapTextBtn:  '#wrapTextBtn',
        fontIncBtn:         '#esLarger',
        fontDecBtn:         '#esSmaller',
        selectAllBtn:       '#esSelectAll',
        searchWidgetPH:     '[data-searchWidget]'
    },
    initialize: function () {
        var lCh = this.options.lCh;
        this.listenTo(lCh, 'header:setSelectPgNumber',                  this.setSelectPgNumber);
        this.listenTo(lCh, 'header:updatePageSelector',                 this._updatePageSelect); //(also does the # -- this one called when page content changed)
        this.listenTo(lCh, 'header:updateSearchBarAfterPageViewRender', this.updateSearchBarAfterPageViewRender);
        lCh.comply({
            applyLocalSearchFromESWordClick: this.setSearchBarText
        }, this);
    },
    onRender: function () {

        var lc = this.options.lCh,
            noErrorOccured = this.model.docOnServerAndNoFetchErr();

        this.$el.unselectable();

        if (noErrorOccured) {

            this._initSearchBar(this.options.$searchContainer);

            this.ui.toggleWrapTextBtn.toggleButton({
                isActive: lc.request('isTextWrapped'),
                toggleAction: function () {
                    lc.command('toggleTextWrapping');
                },
                activeTitle: 'Unwrap Text',
                inactiveTitle: 'Wrap Text'
            });

            //(pgTextCollection only defined if no error_
            this._updatePageSelect(this.options.pgTextCollection, lc.request('currentPgNumber'));
        }

    },
    serializeData: function () {
        return {
            error: !this.model.docOnServerAndNoFetchErr()
        };
    },
    events: function () {
        var c = this.options.lCh;
        return {
            'change @ui.pageSelect': 'pageSelected',
            'click  @ui.fontIncBtn': function () {
                c.command('changeFontSize', 'larger');
            },
            'click  @ui.fontDecBtn': function () {
                c.command('changeFontSize', 'smaller');
            },
            'click  @ui.selectAllBtn': function (e) {
                c.command('selectAll', e);
                /* need to prevent default */
            }

        };

    },
    _updatePageSelect: function (pgs, pgNum) {

        this.ui.pageSelect.find('option').remove();

        var nPgs = pgs ? pgs.length : 0,  //(eg none if doc not on es server, error)
            markup = PageSelectTemplate({
                pages: !nPgs ? [] : pgs.map(function (p) {
                    return {
                        label: p.get('pgLbl'),
                        number: p.get('pgNum')
                    };
                })
            });
        this.ui.pageSelect.append(markup);
        pgNum && this.setSelectPgNumber(pgNum);

        this.ui.pageSelect.toggleClass('invisible', nPgs < 1); //(don't show the page select if there are no pages)
    },
    setSelectPgNumber: function (pgNum) {
        this.ui.pageSelect.val(pgNum);
    },
    pageSelected: function (e) {
        this.options.lCh.command('pageSelect:pageChange', parseInt($(e.currentTarget).val()));
    },
    _initSearchBar: function () {

        var lCh = this.options.lCh,

        /* cache for perf boost */
            _activeHitHighlightCB = lCh._commands['searchBar:localHitActivated'].callback,
            _searchBarKeyUpGrepMode = lCh._commands['searchbar:postKeyupInGrepMode'].callback,
            _keyUpNotGrepMode = lCh._commands[ 'searchBar:postKeyUpNotGrepMode'].callback,
            _cxt = lCh._commands['searchBar:localHitActivated'].context,

            searchView = new SearchBarView({
                placeHolder: 'Find Here',
                includeNAV: true,
                includeGrep: true,
                startInGrepMode: lCh.request('inLocalGrepMode'),
                $searchContainer: this.options.$searchContainer,
                initialSearchTxt: lCh.request('getLocalSearchTxt'),
                onAfterFocus: function () {
                    lCh.command('searchbar:focused');
                },
                preCollapse: function () {
                    lCh.command('searchBar:collapsed');
                },
                onAfterHighlightActiveHit: function ($activeHit) {
                    if ($activeHit.length > 0) _activeHitHighlightCB.apply(_cxt, arguments);
                },
                keyUp: function() {
                    _keyUpNotGrepMode.apply(_cxt, arguments); //not using bind for perf
                },
                onAfterKeyUpInGrepMode: function () {
                    _searchBarKeyUpGrepMode.apply(_cxt, arguments);
                },
                onToggleGrep: function (mode, searchTxt) {
                    lCh.command('toggleLocalGrepMode', {
                        mode: mode,
                        searchTxt: searchTxt
                    });
                }
            });
        this.children.add(searchView, 'searchBar');
        this.ui.searchWidgetPH.replaceWith(searchView.render().$el);
    },
    updateSearchBarAfterPageViewRender: function ($searchContainer, highlightHitIndex) {
        var sb = this.children.findByCustom('searchBar');
        sb.triggerMethod('content:reset', $searchContainer, highlightHitIndex);
    },
    setSearchBarText: function(txt) {
        var sb = this.children.findByCustom('searchBar');
        //sb.triggerMethod('content:reset', $searchContainer, txt); --TODO: combo
        sb.triggerMethod('setSearchText', txt);
    },
    onBeforeDestroy: function () {
        //_.invoke([this.ui.toggleWrapTextBtn, this.children.findByCustom('searchBar')], 'destroy');
        //if in err view error the above won't exit -- would really want equivalent of 'blind trigger'
        var $wrapTxtBtn = this.ui.toggleWrapTextBtn,
            searchBar = this.children.findByCustom('searchBar');

        $wrapTxtBtn.length > 0 && $wrapTxtBtn.destroy();
        searchBar && searchBar.destroy();
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/header/view.js
 ** module id = 526
 ** module chunks = 0
 **/